import { createContext } from 'react'

const youtubeAPIContext = createContext()

export default youtubeAPIContext
